/**
 * API client for project branches (default, active-coder, all).
 *
 * Backend returns `{status: "success", data: BranchesResponse}`.
 */

import { apiRequest } from "./client";

export type ActiveCoderBranchStatus = "in_progress" | "blocked" | "in_review";

export interface ActiveCoderBranch {
  branch_name: string;
  task_id: string;
  task_ticket: string | null;
  task_title: string;
  task_status: ActiveCoderBranchStatus;
  agent_name: string | null;
  agent_color: string | null;
}

export interface BranchesResponse {
  default: string;
  active_coder_branches: ActiveCoderBranch[];
  all_branches: string[];
}

interface ApiResponse<T> {
  status: "success";
  data: T;
}

export async function fetchBranches(
  projectId: string,
): Promise<BranchesResponse> {
  const res = await apiRequest<ApiResponse<BranchesResponse>>(
    `/api/v1/projects/${projectId}/branches/`,
    { silent: true },
  );
  return res.data;
}
